import styled from 'styled-components';

export const SettingWrapper = styled.div`
  max-width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.padding.xxlarge};
  margin-bottom: ${({ theme }) => theme.margin.xxlarge};
  border: 1px solid ${({ theme }) => theme.colors.system.grey};
  border-radius: ${({ theme }) => theme.borders.radius};
`;

export const SettingTitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.margin.standard};
  margin-bottom: ${({ theme }) => theme.margin.standard};
`;
